module.exports = __webpack_public_path__ + "assets/static/media/bootstrap.237339f4.scss";